import { messages } from '@qality/common-messages';
import { TestCycle } from '@qality/common-model';
import { StorageOfUniqueServices } from '@qality/common-service';

import FlagService from './FlagService';
import TestCycleService from './TestCycleService';

export default {
  async deleteTestCycle(
    testCycle: TestCycle,
    detailsPageOpen: boolean
  ): Promise<void> {
    try {
      await TestCycleService.deleteTestCycle(testCycle.id);
      if (detailsPageOpen) {
        window.open(
          await StorageOfUniqueServices.get('URLService').getTestCyclesUrl(
            testCycle.project.key,
            testCycle.project.id
          ),
          '_parent'
        );
      } else {
        FlagService.createSuccessFlag(
          'Success',
          messages['testCycle.delete.success']
        );
      }
    } catch (e) {
      StorageOfUniqueServices.get('ErrorHandlingUtils').handleError(
        e,
        messages['error.deleteTestCycle.message']
      );
    }
  },

  async cloneTestCycle(testCycleId: number): Promise<void> {
    try {
      await TestCycleService.cloneTestCycle(testCycleId);
    } catch (e) {
      StorageOfUniqueServices.get('ErrorHandlingUtils').handleError(
        e,
        messages['error.cloneTestCycle.message']
      );
    }
  },
};
